<template>
  <div>
    <b-overlay
      :opacity="0"
      :show="isLoading"
      class="mb-4"
      spinner-variant="warning"
    >
      <div class="row">
        <template v-if="vacancies.length">
          <div class="col-12 col-md-9" v-for="v in vacancies" :key="v.uid">
            <vacancyCard :v="v" @removed="updateList" />
          </div>
        </template>
        <template v-if="!isLoading && !vacancies.length">
          <div class="col-12">
            <div class="no-data text-center py-4 my-4">
              <h5 class="mb-4 mt-4">Нічого не знйдено</h5>
              <img src="@/assets/img/no-data.svg" width="220" alt="" />
            </div>
          </div>
        </template>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import vacancyCard from "@/components/candidate/vacancy-card.vue";
export default {
  components: {
    vacancyCard,
  },
  data() {
    return {
      isLoading: false,

      vacancies: [],
    };
  },
  watch: {
    list: {
      handler() {
        this.getVacancies();
      },
    },
  },
  computed: {
    list() {
      return this.$store.state.userData.favourites;
    },
    user() {
      return this.$store.state.userData;
    },
  },
  methods: {
    updateList() {
      this.getVacancies();
    },
    async getVacancies() {
      this.isLoading = true;
      this.vacancies = [];
      if (this.user.favourites) {
        let ids = this.user.favourites;
        ids.forEach((id) => {
          this.fetchVacancyById(id);
        });
      }

      this.isLoading = false;
    },
    async fetchVacancyById(id) {
      this.isLoading = true;

      const args = {
        collectionName: "vacancies",
        order: ["deadline", "desc"],
        where: ["id", "==", Number(id)],
      };
      let result = await this.$db.getCollection(args);

      result.docs.forEach((el) => {
        this.vacancies.push(el);
      });
      this.isLoading = false;
    },
  },
  mounted() {
    this.getVacancies();
  },
};
</script>

<style lang="scss" scoped></style>
